const state = {
    heading: '',
    posts: [],
    highlightPosts: [],
    pills: [],
    columns: 2,
    highlightNumber: 4,
    page: 0,
    postsPerPage: 10,
    loading: false,

}

export default state;